import { createStyles, makeStyles } from "@mui/styles";
import { CommonFonts } from "@/theme";

const useStyles = makeStyles((theme) =>
  createStyles({
    periodText: {
      ...CommonFonts.darkFont16,
    },
    dateRangeText: {
      ...CommonFonts.darkBoldFont22,
      cursor: "pointer",
    },
  })
);

export default useStyles;
